import ApiService from "./base";
import { config } from "@/utils/config";
export default class MfaService extends ApiService {
    constructor(){
        super({
            baseURL: `${config.apiUrl}/auth/mfa`
        });
    }
    /**
   * Initiates MFA setup by generating a TOTP secret.
   * Returns the secret code that can be used to generate a QR code.
   */ async setup() {
        const response = await this.post({
            url: "/setup"
        });
        return response.data;
    }
    /**
   * Verifies the MFA setup with a TOTP code from the user's authenticator app.
   * This completes the MFA setup process and enables MFA for the user.
   */ async verify(data) {
        const response = await this.post({
            url: "/verify",
            data
        });
        return response.data;
    }
    /**
   * Responds to an MFA challenge during login.
   * This is called after the user receives an MFA challenge from the login endpoint.
   */ async challenge(data) {
        const response = await this.post({
            url: "/challenge",
            data
        });
        return response.data;
    }
    /**
   * Gets the MFA status for the currently authenticated user.
   */ async getStatus() {
        const response = await this.get({
            url: "/status"
        });
        return response.data;
    }
    /**
   * Initiates MFA setup during MFA_SETUP challenge flow.
   * Uses the session from the challenge instead of requiring authentication.
   */ async setupChallenge(data) {
        const response = await this.post({
            url: "/setup-challenge",
            data
        });
        return response.data;
    }
    /**
   * Verifies the TOTP code and completes the MFA_SETUP challenge.
   * Returns authentication tokens upon successful verification.
   */ async verifyChallenge(data) {
        const response = await this.post({
            url: "/verify-challenge",
            data
        });
        return response.data;
    }
    /**
   * Generates an otpauth URL for QR code generation.
   * @param secretCode - The TOTP secret code from the setup response
   * @param email - The user's email address
   * @param issuer - The application name (defaults to 'Qrypt Portal')
   */ static generateOtpAuthUrl(secretCode, email, issuer = "Qrypt Portal") {
        const encodedIssuer = encodeURIComponent(issuer);
        const encodedEmail = encodeURIComponent(email);
        return `otpauth://totp/${encodedIssuer}:${encodedEmail}?secret=${secretCode}&issuer=${encodedIssuer}`;
    }
}
